<style scoped="scoped" lang="scss"></style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/custom/yongxin/standard/energy/consumption/setting/page" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('shebeimingcheng')">
            <yi_data_select multiple type="equipment" :placeholder="$t('suoyoushebei')" :ids.sync="yt.conditions.equipmentIds"></yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('suoshuzuzhi')">
            <yi_data_select type="organization" :ids.sync="yt.conditions.orgId"> </yi_data_select>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear()">{{ $t('chongzhi') }} </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>

      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <el-button v-if="utils.checkPower('web_base_customize_yongxin_standard_energy_consumption_create')" size="mini" type="primary" @click="yt.showEditDialog('xinzeng', null, 'w1', beforeShowEditDialogInsert)">
          {{ $t('xinzeng') }}
        </el-button>
        <el-button v-if="utils.checkPower('web_base_customize_yongxin_standard_energy_consumption_import')" size="mini" plain @click="importShow = !importShow">
          {{ $t('daoru') }}
        </el-button>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"> </el-button>
      </template>
      <template #meixiaoshibiaozhunhaodianxiaxian="scope">
        <span>{{ scope.row.lowerLimit && scope.row.lowerLimit.toFixed(1) }}</span>
      </template>
      <template #meixiaoshibiaozhunhaodianshangxian="scope">
        <span>{{ scope.row.upperLimit && scope.row.upperLimit.toFixed(1) }}</span>
      </template>
      <!-- 操作插槽 -->
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('bianji', scope.row, null, beforeShowEditDialogEdit)" v-if="utils.checkPower('web_base_customize_yongxin_standard_energy_consumption_update')">{{ $t('bianji') }} </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" class="font-color-danger" :loading="yt.editObj.loading" @click="yt.remove(scope.row, '/custom/yongxin/standard/energy/consumption/setting/delete')" v-if="utils.checkPower('web_base_customize_yongxin_standard_energy_consumption_delete')">{{ $t('shanchu') }} </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>

    <!-- 新增/编辑弹框 -->
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- 新增表单 -->
      <template v-if="yt.editObj.action == 'xinzeng'">
        <el-form :inline="true" ref="form" size="mini" label-width="200px">
          <el-form-item :label="$t('shebeimingcheng')" required>
            <yi_data_select type="equipment" :placeholder="$t('qingxuanze')" :ids.sync="yt.editObj.equipmentId"></yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('meixiaoshibiaozhunhaodianxiaxian')" required>
            <el-input-number v-model="yt.editObj.lowerLimit" :precision="1" :step="0.1" :min="0"></el-input-number>
          </el-form-item>
          <el-form-item :label="$t('meixiaoshibiaozhunhaodianshangxian')" required>
            <el-input-number v-model="yt.editObj.upperLimit" :precision="1" :step="0.1" :min="0"></el-input-number>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button size="mini" @click="yt.req('POST', '/custom/yongxin/standard/energy/consumption/setting/create')" :loading="yt.editObj.loading" type="primary">{{ $t('baocun') }} </el-button>
        </span>
      </template>
      <!-- 更新表单 -->
      <template v-if="yt.editObj.action == 'bianji'">
        <el-form :inline="true" ref="form" size="mini" label-width="200px">
          <el-form-item :label="$t('shebeimingcheng')" required>
            <yi_data_select type="equipment" disabled :placeholder="$t('qingxuanze')" :ids.sync="yt.editObj.equipmentId"></yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('meixiaoshibiaozhunhaodianxiaxian')" required>
            <el-input-number v-model="yt.editObj.lowerLimit" :precision="1" :step="0.1" :min="0"></el-input-number>
          </el-form-item>
          <el-form-item :label="$t('meixiaoshibiaozhunhaodianshangxian')" required>
            <el-input-number v-model="yt.editObj.upperLimit" :precision="1" :step="0.1" :min="0"></el-input-number>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button size="mini" @click="yt.req('POST', '/custom/yongxin/standard/energy/consumption/setting/update')" :loading="yt.editObj.loading" type="primary">{{ $t('baocun') }} </el-button>
        </span>
      </template>
    </el-dialog>

    <!-- 导入 -->
    <import_standard :show.sync="importShow" />
  </div>
</template>
<script type="text/javascript">
import import_standard from './import_standard.vue';

export default {
  name: 'web_customize_yongxin_base_standard_energy_consumption_list',
  components: {
    import_standard
  },
  data() {
    return {
      importShow: false,
      columns: [
        {
          label: 'shebeimingcheng',
          prop: 'equipmentInfo.name'
        },
        {
          label: 'suoshuzuzhi',
          prop: 'orgInfo.name'
        },
        {
          label: 'meixiaoshibiaozhunhaodianxiaxian',
          prop: 'lowerLimit',
          type: 'slot'
        },
        {
          label: 'meixiaoshibiaozhunhaodianshangxian',
          prop: 'upperLimit',
          type: 'slot'
        },
        {
          label: 'chuangjianren',
          prop: 'createByObject.nickname'
        },
        {
          label: 'chuangjianshijian',
          prop: 'createTime',
          type: 'time',
          width: 180
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 150,
          fixed: 'right'
        }
      ]
    };
  },
  destroyed() {
    this.utils.event_hub.$off('YONGXIN_STANDARD_ENERGY_CONSUMPTION_REFRESH');
  },
  created() {
    setTimeout(() => {
      this.yt.get(1);

      this.utils.event_hub.$on('YONGXIN_STANDARD_ENERGY_CONSUMPTION_REFRESH', () => {
        this.yt.get();
      });
    }, 300);
  },
  methods: {
    // 新增之前处理数据
    beforeShowEditDialogInsert(row) {
      return row;
    },

    // 编辑之前处理数据
    beforeShowEditDialogEdit(row) {
      return row;
    }
  }
};
</script>
